import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import fetch from "isomorphic-unfetch";
import uuid from "uuid-random-es";
/**
* A raw HTTP provider, which can be used with an Ethereum node endpoint (JSON-RPC), or an `HttpProviderOptions` object.
*/

var provider = {
  isProvider: function isProvider(a) {
    return "string" == typeof a || "object" == typeof a && void 0 !== a.url;
  },
  send: function () {
    var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a, b, c) {
      var d, e, f, g, _yield$g$json, h, i;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              d = "string" == typeof a ? a : a.url;
              e = "object" == typeof a ? a.params : {};
              f = getPayload(b, c);
              _context.next = 5;
              return fetch(d, _objectSpread({
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(f),
                cache: "no-cache"
              }, e));

            case 5:
              g = _context.sent;

              if (g.ok) {
                _context.next = 8;
                break;
              }

              throw new Error("Request failed with HTTP error ".concat(g.status, ": ").concat(g.statusText));

            case 8:
              _context.next = 10;
              return g.json();

            case 10:
              _yield$g$json = _context.sent;
              h = _yield$g$json.error;
              i = _yield$g$json.result;

              if (!h) {
                _context.next = 15;
                break;
              }

              throw new Error("Request failed: ".concat(h.message));

            case 15:
              return _context.abrupt("return", i);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function send(_x, _x2, _x3) {
      return _send.apply(this, arguments);
    }

    return send;
  }()
};
export default provider;
/**
* Get the JSON-RPC payload for the `eth_call` function.
*/

export var getPayload = function getPayload(a, b) {
  return {
    jsonrpc: "2.0",
    method: a,
    params: b,
    id: uuid()
  };
};